// Import immagini categorie
import exclusive from '../assets/categories/exclusive.jpg';
import buoni from '../assets/categories/buoni.jpg';
import buoni_alimentari from '../assets/categories/buoni_alimentari.jpg';
import buoni_carburante from '../assets/categories/buoni_carburante.jpg';
import casa from '../assets/categories/casa.jpg';
import sport_hobby from '../assets/categories/sport_hobby.jpg';
import esperienza_servizi from '../assets/categories/esperienza_servizi.jpg';
import tech from '../assets/categories/tech.jpg';
import gourmet from '../assets/categories/gourmet.jpg';
import per_lui from '../assets/categories/per_lui.jpg';
import per_lei from '../assets/categories/per_lei.jpg';
import bambini from '../assets/categories/bambini.jpg';
import coming_soon from '../assets/categories/coming_soon.png';

/**
 * Mapping tra ID categoria (key) e immagine corrispondente
 * Gli ID corrispondono a quelli definiti nella configurazione del sistema
 */
export const categoryImageMap: Record<string, string> = {
  // Categorie principali wishlist
  '598752': exclusive,        // Exclusive
  '24773': casa,              // Casa e Design
  '24772': sport_hobby,       // Sport e Hobby
  '24776': esperienza_servizi, // Esperienze e Servizi
  '24775': tech,              // Hi-Tech / Hi-Tec
  '24774': gourmet,           // Gourmet
  '24771': per_lui,           // Per Lui
  '24711': per_lei,           // Per Lei
  '76809': bambini,           // Bambini
  '595316': buoni,            // Buoni (se presente nel sistema)
  '595316-BAWL': buoni_alimentari,  // Buoni alimentari (sottocategoria di Buoni)
  '595316-BCWL': buoni_carburante,  // Buoni carburante (sottocategoria di Buoni)
  
  // Categorie servizi medici/salute
  // 'visite_mediche': visite_mediche, // Visite Mediche (se implementate)
  
  // Immagine di fallback per categorie senza immagine specifica
  'default': coming_soon,
};

/**
 * Funzione per ottenere l'immagine di una categoria dal suo ID
 * @param categoryKey - L'ID della categoria (campo "key")
 * @returns Il path dell'immagine corrispondente o immagine di default
 */
export const getCategoryImage = (categoryKey: string): string => {
  return categoryImageMap[categoryKey] || categoryImageMap['default'];
};

/**
 * Verifica se una categoria ha un'immagine specifica
 * @param categoryKey - L'ID della categoria
 * @returns true se ha un'immagine specifica, false se usa quella di default
 */
export const hasCategoryImage = (categoryKey: string): boolean => {
  return categoryKey in categoryImageMap && categoryKey !== 'default';
};
